import { Component, Input, OnInit, TemplateRef } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_Funds_Interface, Funds_Interface } from 'src/app/Interface/Funds_Interface';
import { Empty_User_Interface, User_Interface } from 'src/app/Interface/User_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { FundsService } from 'src/app/Service/Funds/Funds.service';
import { PriceService } from 'src/app/Service/Price/Price.service';

@Component({
  selector: 'app-FundsForm',
  templateUrl: './FundsForm.component.html',
  styleUrls: ['./FundsForm.component.css']
})
export class FundsFormComponent implements OnInit {

  @Input() inner_User:User_Interface=Empty_User_Interface()
  InProccessing: boolean = false
  modalRef_Delete: any;
  page:any

  DataList_Funds: Array<Funds_Interface> = []
  Data_Seleted_Delete: Funds_Interface = Empty_Funds_Interface()

  constructor(
    private Funds_Service: FundsService,
    private Price_Service: PriceService,
    private modalService: BsModalService,
    private Alertify_Service:AlertifyService
  ) { }

  ngOnInit() {

    this.FundsForm=new FormGroup({
      id :new FormControl(),
      Price:new FormControl(null,Validators.required),
      PriceAlpah:new FormControl(null),
      Dsc:new FormControl(null),
      Date:new FormControl(null,Validators.required),
    })

    this.ReadData_Funds()
  }

  //#region  Form Add

    FundsForm:FormGroup;

    get_Form_Price(){
      return this.FundsForm.get('Price') as FormControl;
    }

    get_Form_PriceAlpah(){
      return this.FundsForm.get('PriceAlpah') as FormControl;
    }

    get_Form_Dsc(){
      return this.FundsForm.get('Dsc') as FormControl;
    }

    get_Form_Date(){
      return this.FundsForm.get('Date') as FormControl;
    }

    pishPardakht_Change() {
      this.Price_Service.GetPriceAlphabet(this.get_Form_Price().value).subscribe(
        data => {
          this.get_Form_PriceAlpah().setValue(data['price'])
        }
      )
    }

    //#endregion

  OnSubmit() {

    this.InProccessing=true
    this.Funds_Service.AddEditFunds(
      this.inner_User.id,
      Number(this.get_Form_Price().value),
      this.get_Form_Date().value,
      this.get_Form_Dsc().value).subscribe(
      data=>{
        this.InProccessing=false
        this.FundsForm.reset()
        this.ReadData_Funds()
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
      },error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )


  }

  ReadData_Funds() {
    this.InProccessing = true
    this.Funds_Service.GetDetail(this.inner_User.id).subscribe(
      data => {
        this.DataList_Funds = data
        this.InProccessing = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Delete(item: User_Interface) {
    this.InProccessing  = true
    this.modalRef_Delete.hide()
    this.Funds_Service.DeleteFunds(item.id).subscribe(
      data => {
        this.InProccessing  = false
        if (data['id'] == -1)
        {
          this.Alertify_Service.ErrorMessage("امکان حذف پرداخت وجود ندارد")
        }
        else {
          this.Alertify_Service.SuccessMessage("حذف شد")
          this.ReadData_Funds()
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )
  }

  openModal(template: TemplateRef<any>, Record) {
    this.Data_Seleted_Delete = Record
    this.modalRef_Delete = this.modalService.show(template);
  }

}
